import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainPage from './pages/MainPage';
import ApiTest from './components/ApiTest';
import NotFoundPage from './components/common/NotFoundPage';
import AdminRouteWrapper from './components/common/AdminRouteWrapper';
import InterviewRouteWrapper from './components/common/InterviewRouteWrapper';
import { AcceptInvitationPage } from './components/admin/AcceptInvitationPage';
import './App.css';

function App() {
  return (
    <Router>
      <div style={{ minHeight: '100vh' }}>
        <Routes>
          <Route path="/" element={<MainPage />} />

          {/* トークンベースの面接ルート（新形式） */}
          <Route path="/interview" element={<InterviewRouteWrapper />} />

          {/* 招待受諾ページ */}
          <Route path="/admin/accept-invitation" element={<AcceptInvitationPage />} />

          {/* 企業IDなしの/adminアクセスは404を表示 */}
          <Route path="/admin" element={<NotFoundPage type="admin" />} />

          {/* 企業IDありの管理画面ルート */}
          <Route path="/admin/:companyId/*" element={<AdminRouteWrapper />} />

          <Route path="/api-test" element={<ApiTest />} />

          {/* その他の未定義ルートは一般的な404を表示 */}
          <Route path="*" element={<NotFoundPage type="general" />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
